'use strict';
import angular from 'angular';

angular.module('widget.create.constants', [])

    .constant('$WidgetCreateEvents', {
        INIT_CREATE: '$WidgetCreateEvents:INIT_CREATE',
        CREATED_FROM_LIBRARY: '$WidgetCreateEvents:CREATED_FROM_LIBRARY',
        CREATED: '$WidgetCreateEvents:CREATED'
    });